import { type Registry as Services, service } from '@ember/service';
import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import {
  NUMBER_FORMATS,
  NUMBER_STYLES,
} from 'lumen/utils/constants/benchmark-insight/beni-constant-values';

export default class BeniBreakdownPeriodSegmentIndex extends Model {
  [Type] = 'benchmark-insight/breakdown-period-segment-index' as const;

  @attr('number') declare ari: number | null;
  @attr('number') declare mpi: number | null;
  @attr('number') declare rgi: number | null;

  @service('benchmark-insight/beni-service')
  declare benchmarkInsightBeniService: Services['benchmark-insight/beni-service'];

  get formattedAri(): string {
    return this.benchmarkInsightBeniService.formatNumber(
      this.ari,
      NUMBER_FORMATS.INDEX,
      NUMBER_STYLES.DEFAULT,
    );
  }

  get formattedMpi(): string {
    return this.benchmarkInsightBeniService.formatNumber(
      this.mpi,
      NUMBER_FORMATS.INDEX,
      NUMBER_STYLES.DEFAULT,
    );
  }

  get formattedRgi(): string {
    return this.benchmarkInsightBeniService.formatNumber(
      this.rgi,
      NUMBER_FORMATS.INDEX,
      NUMBER_STYLES.DEFAULT,
    );
  }
}
